
import { Component, Vue, Prop } from 'vue-property-decorator'
import { MenuItem } from '@/interfaces/menu-item'

@Component
export default class SubmenuItem extends Vue {
  @Prop() items: MenuItem[]
}
